import * as React from 'react';
import {ChangeEvent} from 'react';
import {EditableProps} from "../../common/props/EditableProps";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import UserMention from "../../mention/UserMention";
import {none, option} from "ts-option";
import * as validator from "validator";
import {FocusableProps} from "../../common/props/FocusableProps";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";


type Props = EditableProps
	& FormGroupProps<string>
	& PlaceholderProps
	& FocusableProps

export default class MentionFormGroup extends React.Component<Props, {}> {

	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<UserMention onChange={this.onChange}
							 value={this.props.field.value.getOrElse("")}
							 placeholder={this.props.placeholder}
							 minHeight={200}
							 hasBorder
							 focus={this.props.form && this.props.form.hasFocus(this.props.field)}/>
			</FormGroup>
		);
	}

	private onChange(event: ChangeEvent<HTMLTextAreaElement>) {
		const value = event.target.value;
		const valueTrimmed = value.trim();
		this.props.onChange(this.props.field.updateValue(validator.isEmpty(valueTrimmed) ? none : option(value)));
	}
}